import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface SettingsSectionProps {
  title: string;
  options: string[] | Array<{ label: string; key: string }>;
  selectedValue: string | { [key: string]: boolean };
  onSelect: (value: string) => void;
  gridSize: number;
  isMulti?: boolean;
  endAdornment?: React.ReactNode;
}

// Reusable Section Component
const SettingsSection: React.FC<SettingsSectionProps> = ({ title, options, selectedValue, onSelect, gridSize, isMulti = false, endAdornment }) => {
  return (
    <Box sx={{ mb: 2, mt: 0.5 }}>
      <Box sx={{ position: "relative", mb: 1.5 }}>
        <Typography
          variant="h6"
          sx={{
            color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center",
            fontFamily: '"Inter", sans-serif',
          }}
        >
          {title}
        </Typography>
        {endAdornment && (
          <Box sx={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}>
            {endAdornment}
          </Box>
        )}
      </Box>
      {/* Wrapper for border bottom if it's Bonus Settings section (judged by isMulti or title) */}
      <Box
        sx={
          title === "BONUS SETTINGS"
            ? {
              pb: 3,
              borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
            }
            : {}
        }
      >
        <Grid container spacing={1}>
          {options.map((option) => {
            const label = isMulti ? (option as { label: string; key: string }).label : (option as string);
            const value = isMulti ? (option as { label: string; key: string }).key : (option as string);
            const isSelected = isMulti
              ? (selectedValue as { [key: string]: boolean })[value]
              : (selectedValue as string) === value;

            return (
              <Grid item xs={gridSize} key={String(value)}>
                <Button
                  fullWidth
                  onClick={() => onSelect(value)}
                  sx={{
                    backgroundColor: isSelected ? PureLightThemeCaaS.colors.alpha.orange[100] : PureLightThemeCaaS.colors.alpha.black[50],
                    color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                    fontWeight: "bold",
                    borderRadius: "4px",
                    py: 0.75,
                    boxSizing: "border-box",
                    border: `1px solid ${isSelected ? "transparent" : PureLightThemeCaaS.colors.alpha.white[30]}`,
                    textTransform: "uppercase",
                    fontSize: "13px",
                    fontFamily: '"Inter", sans-serif',
                    "&:hover": {
                      backgroundColor: isSelected ? PureLightThemeCaaS.colors.alpha.orange[100] : PureLightThemeCaaS.colors.alpha.black[70],
                      borderColor: isSelected ? "transparent" : `${PureLightThemeCaaS.colors.alpha.white[50]}`,
                    },
                  }}
                >
                  {label === "SF" ? "SUPERFLEX" : label}
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default SettingsSection;
